import styled from 'styled-components'
import { Box, Text } from "@usap/uicomponents"

const darkColor = (props) => props.theme.global.colors['dark-2']
const borderColor = (props) => props.theme.global.colors['divider']

export const ImageUploadContainer = styled(Box)`
  position: relative;
  height: 120px;
`

export const ImageUploadBox = styled(Box)`
  width: 88px;
  height: 88px;
  border: 1px solid ${borderColor};
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const PhotoLabel = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  margin-top: 8px;
  color: ${darkColor};
  text-align: center;
  line-height: 24px;
`
